import { Filter, FileSpreadsheet, Columns, RefreshCw, Building2 } from "lucide-react";
import { TESTIDS } from "@/constants/testIds";

const items = [
  {
    icon: Building2,
    label: "Tipo de datos",
    value: "Empresas · personas · servicios · profesionales · comercio",
  },
  {
    icon: Filter,
    label: "Filtros específicos",
    value: "Región · comuna · rubro · actividad económica · tamaño · fecha",
  },
  {
    icon: FileSpreadsheet,
    label: "Formato de entrega",
    value: "Excel · CSV · SQL · Google Sheets · API",
  },
  {
    icon: Columns,
    label: "Estructura de columnas",
    value: "Solo los campos que te interesan, en el orden que prefieras",
  },
  {
    icon: RefreshCw,
    label: "Frecuencia de actualización",
    value: "Entregas únicas o periódicas (semanal, mensual, trimestral)",
  },
];

export default function Customize() {
  return (
    <section
      data-testid={TESTIDS.customizeSection}
      className="relative py-24 lg:py-32 border-t border-[rgba(0,240,255,0.08)]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 lg:sticky lg:top-32 self-start">
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#00f0ff] mb-4">
              / 02 — Personalización
            </div>
            <h2 className="font-display font-black text-white text-4xl sm:text-5xl leading-[1] tracking-tight mb-6">
              ¿Qué puedes
              <br />
              <span className="italic font-light">personalizar</span>?
            </h2>
            <p className="text-[#94a3b8] text-base leading-relaxed">
              Define exactamente lo que necesitas y nada más. Sin columnas
              vacías, sin filas que filtrar, sin tiempo perdido en limpieza.
            </p>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {items.map((it, i) => {
              const Icon = it.icon;
              return (
                <div
                  key={it.label}
                  className="group flex items-start gap-5 p-6 rounded-2xl border border-[rgba(0,240,255,0.1)] hover:border-[rgba(0,240,255,0.4)] hover:bg-[rgba(0,240,255,0.03)] transition-all"
                >
                  <div className="font-mono text-[11px] text-[#64748b] mt-1 w-6 shrink-0">
                    0{i + 1}
                  </div>
                  <div className="w-11 h-11 rounded-xl bg-[rgba(0,240,255,0.06)] border border-[rgba(0,240,255,0.2)] flex items-center justify-center shrink-0 group-hover:bg-[#00f0ff] group-hover:text-[#040812] transition-colors">
                    <Icon size={18} className="text-[#00f0ff] group-hover:text-[#040812]" />
                  </div>
                  <div className="flex-1">
                    <div className="font-display font-bold text-white text-lg mb-1">
                      {it.label}
                    </div>
                    <div className="text-[14px] text-[#94a3b8] leading-relaxed">
                      {it.value}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
